"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hooks_1 = require("./hooks");
exports.Dropdown = react_1.default.forwardRef(function DropdownBase(_a, ref) {
    var renderContent = _a.renderContent, renderControl = _a.renderControl, renderPopover = _a.renderPopover, popoverConfig = _a.popoverConfig, _b = _a.autoClosable, autoClosable = _b === void 0 ? true : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c, getAdditionalContentNode = _a.getAdditionalContentNode, onDidHide = _a.onDidHide, onDidShow = _a.onDidShow, onOutsideClick = _a.onOutsideClick;
    return hooks_1.useDropdown({
        ref: ref,
        autoClosable: autoClosable,
        renderControl: renderControl,
        renderContent: renderContent,
        renderPopover: renderPopover,
        offset: offset,
        popoverConfig: popoverConfig,
        getAdditionalContentNode: getAdditionalContentNode,
        onDidHide: onDidHide,
        onDidShow: onDidShow,
        onOutsideClick: onOutsideClick
    })[0];
});
exports.Dropdown.defaultProps = {
    autoClosable: true,
    stopPropagation: true,
    offset: 0
};
exports.Dropdown.displayName = 'Dropdown';
//# sourceMappingURL=Dropdown.js.map